import Component from "../../../../js/assets/component.js"
import SmallSlideshow from "../../molecules/small_slideshow/small_slideshow.js"
import EmbedVideo from "../../molecules/embed_video/embed_video.js"

class LpDetailBlock extends Component {
  constructor(el){
    super(el)
  }

  data(){
    return {
      "active": false
    }
  }

  changed(){
    return {
      "active": (val)=>{
        if(val===true){
          this.activate()
        }else{
          this.inActivate()
        }
      }
    }
  }

  activate(){
    this.$el.removeClass("-inActive")
    this.$el.addClass("-active")
    this.smallSlideShow.loadImages()

    if(this.$movieContainer.length!==0){
      this.embedVideo.load()
    }
  }

  inActivate(){
    this.$el.removeClass("-active")
    this.$el.addClass("-inActive")

    if(this.$movieContainer.length!==0){
      this.embedVideo.pause()
    }
  }

  mounted() {

    //smallSlideShow
    this.smallSlideShow = new SmallSlideshow(this.$el.find(".smallSlideShow").get(0))

    //Youtube
    this.$movieContainer = this.$el.find("[data-role='movie_container']")

    if(this.$movieContainer.length !== 0){
      this.embedVideo = new EmbedVideo(this.$movieContainer.attr("data-src"), this.$movieContainer.attr("data-title"),this.$movieContainer.attr("data-video-id"))
      this.$movieContainer.append(this.embedVideo.$el)
    }
  }
}

export default LpDetailBlock
